import { Navigate, useParams } from 'react-router-dom';

/**
 * Editing now lives on the client detail page (Redirect URIs, Credentials,
 * Logout and Settings tabs). This route is kept so existing links still work.
 */
export function ClientEditPage() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/clients/${id}#settings`} replace />;
}
